// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DailyGoal__innerClass___yKJS1 {
    padding-left: 5px;
    position: relative;
    bottom: 1px;
}

.DailyGoal__postDailyGoalLink___lKNg0 {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    top: 1px;
    width: 24px;
    height: 24px;
    margin: 0 6px;
    line-height: 1;
    border-radius: 999px;
    background: radial-gradient(
        circle at 50% 45%,
        hsl(44deg 66% 34% / 0.14) 0%,
        hsl(38deg 48% 18% / 0.08) 72%,
        hsl(38deg 48% 18% / 0.03) 100%
    );
    box-shadow: inset 0 -1px 0 hsl(36deg 46% 12% / 0.18);
    color: hsl(47deg 72% 78%);
    transition:
        background 120ms ease,
        box-shadow 120ms ease,
        color 120ms ease,
        filter 120ms ease,
        transform 120ms ease;
}

.DailyGoal__postDailyGoalLink___lKNg0:hover,
.DailyGoal__postDailyGoalLink___lKNg0:focus {
    background: linear-gradient(
        180deg,
        hsl(46deg 88% 58% / 0.28) 0%,
        hsl(34deg 70% 34% / 0.2) 100%
    );
    box-shadow:
        inset 0 0 0 1px hsl(46deg 92% 72% / 0.34),
        0 0 6px hsl(40deg 90% 56% / 0.12);
    color: white;
}

.DailyGoal__postDailyGoalLink___lKNg0:active {
    filter: brightness(1.12);
    transform: scale(0.94);
}

.DailyGoal__postDailyGoalGlyph___jVMqa {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    font-size: 20px;
    font-weight: 700;
    line-height: 14px;
    transform: translateY(1px);
}

.DailyGoal__isChecked___L1L_o {
    color: yellowgreen;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"innerClass": `DailyGoal__innerClass___yKJS1`,
	"postDailyGoalLink": `DailyGoal__postDailyGoalLink___lKNg0`,
	"postDailyGoalGlyph": `DailyGoal__postDailyGoalGlyph___jVMqa`,
	"isChecked": `DailyGoal__isChecked___L1L_o`
};
module.exports = ___CSS_LOADER_EXPORT___;
